import { Box, Button, Divider, Typography } from "@mui/material";
import Script from "next/script";

export default function FourOhFour() {
    return (
        <>
            <Script
                async
                id="ze-snippet"
                src="https://static.zdassets.com/ekr/snippet.js?key=c4edb3bf-6a0e-4ec6-8625-7d8728a5d40f"
            ></Script>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "25px",
                    height: "100vh",
                    width: "100vw",
                }}
            >
                <Box sx={{ display: "flex", gap: "10px" }}>
                    <img
                        src="https://data-gate.s3.amazonaws.com/clients/28/orange_flag_transparent.png"
                        style={{
                            display: "block",
                            maxWidth: "90%",
                            height: "25px",
                        }}
                    />
                    <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ borderRightWidth: 2 }}
                    />
                    <Typography variant="h6">Page Not Found</Typography>
                </Box>
                <Box>
                    <Typography
                        color="info.light"
                        sx={{ px: 10, textAlign: "center" }}
                    >
                        We couldn&apos;t find the page you were looking for. If
                        you believe this is an error, click the{" "}
                        <b>
                            <i>Help</i>
                        </b>{" "}
                        button below and let us know.
                    </Typography>
                </Box>
            </Box>
        </>
    );
}
